import { Observable } from 'rxjs';

import {
  ICriticalityMetrics,
  IHistoryMetrics,
  IScoreMetrics,
  IStatusMetrics,
  IVentureHistoryMetrics,
  IVentureStatusMetrics,
} from '../interfaces/dashboard';
import apiService, { ApiService } from './api';

type OptionalIdsProps = {
  ventureId?: number;
  categoryId?: number;
  entityId?: number;
  params?: URLSearchParams;
};

type SendScreenshotProps = {
  dataUrl: string;
  email: string;
};

export class DashboardService {
  constructor(private apiService: ApiService) {}

  public getTotalsByStatus(
    params?: URLSearchParams
  ): Observable<IStatusMetrics[]> {
    let url = '/dashboard/totalsByStatus';

    if (params) {
      url += `?${params}`;
    }
    return this.apiService.get(url);
  }

  public getVenturesStatuses(
    params?: URLSearchParams
  ): Observable<IVentureStatusMetrics[]> {
    let url = '/dashboard/status';

    if (params) {
      url += `?${params}`;
    }

    return this.apiService.get(url);
  }

  public getVenturesHistory(
    params?: URLSearchParams
  ): Observable<IVentureHistoryMetrics> {
    let url = '/dashboard/statusByMonth';

    if (params) {
      url += `?${params}`;
    }

    return this.apiService.get(url);
  }

  public getStatus({
    ventureId,
    categoryId,
    entityId,
    params,
  }: OptionalIdsProps): Observable<IVentureStatusMetrics> {
    let path = '/dashboard/status';
    if (ventureId) path += `/${ventureId}`;
    if (categoryId) path += `/${categoryId}`;
    if (entityId) path += `/${entityId}`;
    if (params) {
      path += `?${params}`;
    }

    return this.apiService.get(path);
  }

  public getCriticality({
    ventureId,
    categoryId,
    entityId,
    params,
  }: OptionalIdsProps): Observable<ICriticalityMetrics[]> {
    let path = `/dashboard/criticality/${ventureId}`;
    if (categoryId) path += `/${categoryId}`;
    if (entityId) path += `/${entityId}`;

    if (params) {
      path += `?${params}`;
    }
    return this.apiService.get(path);
  }

  public getScore({
    ventureId,
    categoryId,
    entityId,
    params,
  }: OptionalIdsProps): Observable<IScoreMetrics> {
    let path = `/dashboard/score/${ventureId}`;
    if (categoryId) path += `/${categoryId}`;
    if (entityId) path += `/${entityId}`;
    if (params) {
      path += `?${params}`;
    }
    return this.apiService.get(path);
  }

  public getHistory({
    ventureId,
    categoryId,
    entityId,
    params,
  }: OptionalIdsProps): Observable<IHistoryMetrics> {
    let path = `/dashboard/statusByMonth/${ventureId}`;
    if (categoryId) path += `/${categoryId}`;
    if (entityId) path += `/${entityId}`;
    if (params) {
      path += `?${params}`;
    }
    return this.apiService.get(path);
  }

  public sendScreenshot(data: FormData): Observable<any> {
    return this.apiService.post('/dashboard', data);
  }
}

const dashboardService = new DashboardService(apiService);
export default dashboardService;
